import {t} from "i18next";

// import technoLogoUrl from "../../images/icons/technoLogo.jpeg";
import technoLogoUrl from "../../images/icons/technoLogo2.png";
import {ADVANCE_PROCENT, getImageSize, ORG_STRUCTURES_INFO} from "../generalConstants.js/generalConstants";
import urlToBase64 from "../urlToBase64";

import SKU_PLAN_LIST_ASSET from "./SKU_PLAN_LIST";

export default class COF_ASSET {
  constructor(cof, services) {
    const cofInfo = cof?.cofInfo;

    this.skuPlan = cof?.skuPlan;
    this.SKU_PLAN = new SKU_PLAN_LIST_ASSET(cof?.skuPlan);
    this.services = services;

    this.advance = ADVANCE_PROCENT / 100;
    this.advanceForServices = cof?.advanceForServices;

    this.totalSumWithoutDiscount = cofInfo?.totalSumWithoutDiscount;
    this.discount = cofInfo?.discount;
    this.totalSumWithDiscount = cofInfo?.totalSumWithDiscount;
    this.advancePrice = cofInfo?.advancePrice;
    this.advanceSkuSum = cofInfo?.advanceSkuSum;
    this.surchargePrice = cofInfo?.surchargePrice;
    this.freezedForClient = cof?.freezedForClient;
    this.ordersExist = cof?.ordersExist;

    this.sumPlan = +cof?.sumPlan;

    this.orgStructureId = cof?.co?.orgStructureId;
    this.managerCo = cof?.co?.managerCo;
    this.rejectedProforms = cof?.co?.rejectedProforms;
  }

  get discountSum() {
    return this.totalSumWithoutDiscount - this.totalSumWithDiscount;
  }

  get skuPlanAdvance() {
    return this.advanceForServices ? this.advancePrice : this.advanceSkuSum;
  }

  get hasRejectedSkus() {
    return !!this.rejectedProforms?.length;
  }
  get rejectedFactoryIds() {
    return [...new Set(this.rejectedProforms?.map(({factoryId}) => factoryId))];
  }

  get cannotCofBeChanged() {
    return !this.hasRejectedSkus && this.freezedForClient;
    // || this.ordersExist;
  }

  findIfSkuIdealCanBeAddedToCof(skuIdeal) {
    return this.hasRejectedSkus
      ? Array.isArray(this.rejectedFactoryIds) && this.rejectedFactoryIds.includes(skuIdeal?.factory?.factoryId)
      : !!skuIdeal?.skuPrices?.length &&
          !this?.skuPlan?.find(({skuId}) => skuId === skuIdeal?.skuId) &&
          skuIdeal?.totalInObject &&
          ((skuIdeal?.height && skuIdeal?.length && skuIdeal?.width) || skuIdeal?.weight || skuIdeal?.volume) &&
          skuIdeal?.measurementObject?.objectId &&
          skuIdeal?.measurementUnit?.unitId;
  }
  findIfSkuIdealIsAddedToCof(skuIdeal) {
    return !!this?.skuPlan?.find(({skuId}) => skuId === skuIdeal?.skuId);
  }

  async formPdfHeader(pdfLanguage = "en") {
    let orgStructure = ORG_STRUCTURES_INFO[this.orgStructureId];
    if (!orgStructure || !Object.keys(ORG_STRUCTURES_INFO)?.includes(this.orgStructureId))
      orgStructure = ORG_STRUCTURES_INFO.DEFAULT;

    if (this.orgStructureId === 6) {
      const logo = await urlToBase64(technoLogoUrl);
      const {widthHeightCoef} = await getImageSize(technoLogoUrl);

      const managerName = this.managerCo?.name || "-";
      const managerPhone = this.managerCo?.workingPhone || this.managerCo?.persona?.phone || "-";
      const managerEmail = this.managerCo?.email || this.managerCo?.persona?.email || "-";
      const managerCite = this.managerCo?.settings?.siteUrl || "-";
      const managerAddress = this.managerCo?.settings?.address || "-";

      return [
        {
          margin: [0, 0, 0, 15],
          columns: [
            {
              width: "auto",
              image: logo,
              height: 45,
              // fit: [45 * widthHeightCoef, 45],
              fit: [70 * widthHeightCoef, 70],
              alignment: "left",
            },
            {
              width: "*",
              alignment: "right",
              stack: [
                {
                  text: t("Techno PDF header title", {lng: pdfLanguage}),
                  fontSize: 9,
                },
                {
                  text: managerName,
                  fontSize: 9,
                },
                {
                  text: `${t("tel2", {lng: pdfLanguage, defaultValue: "tel2"})}: ${managerPhone}`,
                  fontSize: 9,
                },
                {
                  text: t(managerAddress, {
                    lng: pdfLanguage,
                    defaultValue: "Київ, вул. Велика Васильківська 13/1",
                  }),
                  fontSize: 9,
                },
                {
                  text: `${t("e-mail", {lng: pdfLanguage, defaultValue: "e-mail"})}: ${managerEmail}`,
                  // text: managerEmail,
                  fontSize: 9,
                },
                {
                  text: `${t("cite", {lng: pdfLanguage, defaultValue: "cite"})}: ${managerCite}`,
                  fontSize: 9,
                },
              ],
            },
          ],
        },
      ];
    }

    const logo = await urlToBase64(orgStructure.logo);

    const {widthHeightCoef} = await getImageSize(orgStructure.logo);

    return [
      {
        image: logo,
        height: 30,
        width: 30 * widthHeightCoef,
        alignment: "center",
      },
      {
        margin: [0, 0, 0, 25],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                text: `${orgStructure.city}. ${orgStructure.street}`,
                style: "header",
                alignment: "left",
                border: [false, false, false, false],
              },
              {
                text: this.managerCo?.name || "",
                style: "header",
                alignment: "right",
                border: [false, false, false, false],
              },
            ],
            [
              {
                text: orgStructure.cite || this.managerCo?.cite || "",
                style: "header",
                alignment: "left",
                border: [false, false, false, true],
              },
              {
                text: this.managerCo?.workingPhone || this.managerCo?.persona?.phone || "",
                style: "header",
                alignment: "right",
                border: [false, false, false, true],
              },
            ],
          ],
        },
        layout: {margin: [0, 5, 5, 5], dontBreakRows: true, noWrap: true},
      },
    ];
  }
}
